<template>
    <div>
        <h1>Loading</h1>
     
    </div>
</template>
<script>
    "use strict"

    export default {
        name: 'loading',
        props: {},
        components: {

    
        },

    }

</script>